import { useState } from 'react';

const carouselItems = [
  {
    title: '暑期档特辑：2026最值得追的10部剧',
    desc: '从古装权谋到现代悬疑，从国产口碑到海外黑马，我们为你精选了这个夏天不容错过的影视盛宴。每部都经过编辑团队认真筛选，保证不踩雷。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20vibe%20with%20warm%20sunset%20colors%2C%20abstract%20film%20frames%20floating%2C%20modern%20entertainment%20atmosphere%2C%20golden%20and%20coral%20tones%2C%20artistic%20composition%2C%20high%20detail%2C%20editorial%20photography&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    title: '追剧党必收：冷门高分剧推荐',
    desc: '有些剧没有铺天盖地的宣传，却有着让人惊艳的品质。我们从近千部作品中挖出了这些评分8.5+的冷门佳作，每一部都是被低估的宝藏，值得你花时间。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20warm%20lamp%20light%2C%20shelves%20of%20films%20and%20books%2C%20intimate%20atmosphere%2C%20discovery%20and%20curation%20theme%2C%20soft%20amber%20glow%2C%20artistic%20interior&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    title: '国产动画崛起：不可错过的国风佳作',
    desc: '从《大圣归来》到《深海》，再到今年的多部力作，国产动画正在经历一场美学革命。我们整理了近年最值得关注的国风动画作品，每一部都是视觉与故事的双重享受。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20painting%20style%20animation%20scene%2C%20misty%20mountains%20with%20flowing%20clouds%2C%20traditional%20art%20aesthetic%2C%20ethereal%20atmosphere%2C%20warm%20earthy%20tones%2C%20poetic%20composition&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    title: '周末刷片指南：4部必看最新电影',
    desc: '最新电影上映信息汇总！本周末有科幻巨制、温情喜剧和深度纪录片可选。无论你是想去电影院还是宅家投屏，这份片单都能让你的周末充满好内容。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Modern%20home%20cinema%20setup%20with%20large%20screen%20and%20comfortable%20seating%2C%20cozy%20evening%20atmosphere%2C%20warm%20ambient%20lighting%2C%20weekend%20relaxation%20vibe%2C%20lifestyle%20photography&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
];

function CarouselCard({ item }: { item: typeof carouselItems[0] }) {
  const [imgError, setImgError] = useState(false);

  return (
    <div className="rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300">
      <div className="relative aspect-[2/1] overflow-hidden">
        {!imgError ? (
          <img
            src={item.imgUrl}
            alt={item.title}
            className="w-full h-full object-cover object-top"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full bg-background-200 flex items-center justify-center">
            <i className="ri-image-line text-4xl text-foreground-300"></i>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
      </div>
      <div className="p-5 md:p-6">
        <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
          {item.title}
        </h3>
        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
          {item.desc}
        </p>
      </div>
    </div>
  );
}

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            编辑团队精心策划的深度专题，帮你发现更多好内容
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item, idx) => (
            <CarouselCard key={idx} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}